<template>
  <b-modal
    id="ModId3"
    ref="modal"
    title="Профиль ФТС"
    size="lg"
    @ok="checkEmulatorField($event)"
    @cancel="clearModal"
    @hidden="clearModal"
    ok-title="Сохранить" ok-variant="success"
    cancel-variant="danger" cancel-title="Отменить"
    :no-close-on-backdrop=true
    :ok-disabled="veeErrors.any() || $parent.supportCheck"
  >
    <b-container fluid v-if="!loading">
      <div class="modal-spinner">
        <b-spinner variant="secondary" label="Загрузка..."></b-spinner>
        <strong class="mt-3">Загрузка...</strong>
      </div>
    </b-container>
    <b-form ref="form" @submit.stop.prevent="onSubmit" v-else>
      <b-container fluid>
        <b-row>
          <b-form-group class="inline" v-if="hasDefaultFcsRight()"
                        label="Использовать профиль Даобит"
                        label-class="mf-label mb-0 d-flex align-items-center"
                        label-for="default"
          >
            <b-form-checkbox id="default"
                             v-model="model.p_default"
                             type="checkbox"
                             class="ml-4"
            >
            </b-form-checkbox>
          </b-form-group>
          <b-form-group class="inline"
                        label="Эмулятор сообщений"
                        label-class="mf-label mb-0 d-flex align-items-center"
                        label-for="emulator"
          >
            <b-form-checkbox id="emulator"
                             v-model="model.p_emulator"
                             type="checkbox"
                             class="ml-4"
            >
            </b-form-checkbox>
          </b-form-group>
        </b-row>
        <b-row class="pb-4">
          <b-col md="6" class="pl-0">
            <div class="d-flex justify-content-between">
            <b-button variant="success" size="sm" :disabled="loadInfodecDataDisabled || $parent.supportCheck" class="infodec-link"
                      id="fcs-profile" @click="getDataFromInfodec(companyDataFromTable)" style="width: 220px;">Загрузить данные
              из Инфодек
            </b-button>
            <b-button size="sm" @click="openFileLoader" :disabled="loadInfodecDataDisabled || $parent.supportCheck">Загрузить из xml</b-button>
            <b-form-file
              id="xmlLoader"
              v-show="false"
              v-model="xmlFile"
              :disabled="loadInfodecDataDisabled"
              :placeholder="'Загрузить xml'"
              @input="loadXml($event)"
              class="ml-2"
              size="sm"
              accept=".xml">
            </b-form-file>
            </div>
            <b-popover
              target="fcs-profile"
              placement="bottomright"
              triggers="focus"
              custom-class="infodec-popover"
              id="infodec-popover"
            >
              <b-table :items="infodec"
                       :fields="fields"
                       :busy="busyModalTable"
                       show-empty
                       hover
                       responsive
                       @row-clicked="setFCSData"
                       empty-text="Данные отсутствуют"
                       id="my-table">
                <template v-slot:table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Загрузка...</strong>
                  </div>
                </template>
              </b-table>
            </b-popover>
          </b-col>
        </b-row>
        <b-row class="pb-3">
          <b-col md="6" class="pl-0">
            <b-form-group
              :label="isDefault.participant_id.label"
              label-for="participant-id-input"
              label-class="mf-label"
              :invalid-feedback="getError('participant-id-input')"
            >
              <b-form-input
                id="participant-id-input"
                name="participant-id-input"
                v-model="model.p_participant_id"
                v-validate="isDefault.participant_id.validation"
                data-vv-as="ID декларанта"
                :state="validateState('participant-id-input')"
                :disabled="isDefault.participant_id.disabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" class="pr-0">
            <b-form-group
              :label="isDefault.username.label"
              label-for="username-input"
              label-class="mf-label"
              :invalid-feedback="getError('username-input')"
            >
              <b-form-input
                id="username-input"
                name="username-input"
                v-model="model.p_username"
                v-validate="isDefault.username.validation"
                data-vv-as="Логин"
                :state="validateState('username-input')"
                :disabled="isDefault.username.disabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="pb-3">
          <b-col md="6" class="pl-0">
            <b-form-group
              :label="isDefault.password.label"
              label-for="password-input"
              label-class="mf-label"
              :invalid-feedback="getError('password-input')"
            >
              <b-form-input
                id="password-input"
                name="password-input"
                v-model="model.p_password"
                v-validate="isDefault.password.validation"
                data-vv-as="Пароль"
                :state="validateState('password-input')"
                :disabled="isDefault.password.disabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" class="pr-0">
            <b-form-group
              :label="isDefault.senderInfo.label"
              label-for="sender-info-input"
              label-class="mf-label"
              :invalid-feedback="getError('sender-info-input')"
            >
              <b-form-input
                id="sender-info-input"
                name="sender-info-input"
                v-model="model.p_sender_info"
                v-validate="isDefault.senderInfo.validation"
                data-vv-as="Адрес отправителя"
                :state="validateState('sender-info-input')"
                :disabled="isDefault.senderInfo.disabled"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <span v-if="!modalParamsGroupFCS.method_data.p_is_inn_correct" class="text-danger" style="font-size: smaller;">• Некорректный ИНН</span>
      </b-container>
    </b-form>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { validation } from './validation'

export default {
  name: 'fcs-profile',
  mixins: [validation],
  data () {
    return {
      xmlFile: null,
      companyDataFromTable: null,
      loading: null,
      type: null,
      loadInfodecDataDisabled: false,
      model: {
        p_default: false,
        p_emulator: false,
        p_participant_id: '',
        p_username: '',
        p_password: '',
        p_sender_info: '',
        p_gid: null
      },
      p_gid: null,
      fields: [
        { key: 'participant_id', label: 'ID Декларанта' },
        { key: 'login', label: 'Логин' }
      ],
      isDefault: {
        participant_id: {
          label: 'ID декларанта *',
          disabled: false,
          validation: {
            required: true,
            numeric: true
          }
        },
        username: {
          label: 'Логин *',
          disabled: false,
          validation: {
            required: true
          }
        },
        password: {
          label: 'Пароль *',
          disabled: false,
          validation: {
            required: true
          }
        },
        senderInfo: {
          label: 'Адрес отправителя *',
          disabled: false,
          validation: {
            required: true
          }
        }
      }
    }
  },
  watch: {
    modalParamsGroupFCS () {
      this.model.p_default = Boolean(this.modalParamsGroupFCS.method_data.p_default)
      this.model.p_emulator = Boolean(this.modalParamsGroupFCS.method_data.p_emulator)
      this.model.p_participant_id = this.modalParamsGroupFCS.method_data.p_participant_id
      this.model.p_username = this.modalParamsGroupFCS.method_data.p_username
      this.model.p_password = this.modalParamsGroupFCS.method_data.p_password
      this.model.p_sender_info = this.modalParamsGroupFCS.method_data.p_sender_info
    },
    'model.p_default' () {
      if (this.model.p_default === true) {
        this.model.p_emulator = false
        this.loadInfodecDataDisabled = true
        this.isDefault = {
          participant_id: {
            label: 'ID декларанта',
            disabled: true,
            validation: {
              required: false
            }
          },
          username: {
            label: 'Логин',
            disabled: true,
            validation: {
              required: false
            }
          },
          password: {
            label: 'Пароль',
            disabled: true,
            validation: {
              required: false
            }
          },
          senderInfo: {
            label: 'Адрес отправителя',
            disabled: true,
            validation: {
              required: false
            }
          }
        }
      } else if (this.model.p_emulator === false) {
        this.loadInfodecDataDisabled = false
        this.isDefault = {
          participant_id: {
            label: 'ID декларанта *',
            disabled: false,
            validation: {
              required: true,
              numeric: true
            }
          },
          username: {
            label: 'Логин *',
            disabled: false,
            validation: {
              required: true
            }
          },
          password: {
            label: 'Пароль *',
            disabled: false,
            validation: {
              required: true
            }
          },
          senderInfo: {
            label: 'Адрес отправителя *',
            disabled: false,
            validation: {
              required: true
            }
          }
        }
      }
    },
    'model.p_emulator' () {
      if (this.model.p_emulator === true) {
        this.model.p_default = false
        this.loadInfodecDataDisabled = true
        this.isDefault = {
          participant_id: {
            label: 'ID декларанта',
            disabled: true,
            validation: {
              required: false
            }
          },
          username: {
            label: 'Логин',
            disabled: true,
            validation: {
              required: false
            }
          },
          password: {
            label: 'Пароль',
            disabled: true,
            validation: {
              required: false
            }
          },
          senderInfo: {
            label: 'Адрес отправителя',
            disabled: true,
            validation: {
              required: false
            }
          }
        }
      } else if (this.model.p_default === false) {
        this.loadInfodecDataDisabled = false
        this.isDefault = {
          participant_id: {
            label: 'ID декларанта *',
            disabled: false,
            validation: {
              required: true,
              numeric: true
            }
          },
          username: {
            label: 'Логин *',
            disabled: false,
            validation: {
              required: true
            }
          },
          password: {
            label: 'Пароль *',
            disabled: false,
            validation: {
              required: true
            }
          },
          senderInfo: {
            label: 'Адрес отправителя *',
            disabled: false,
            validation: {
              required: true
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapState(
      {
        modalParamsGroupFCS: state => state.groupsUsers.modalParamsGroupFCS,
        infodec: state => state.groupsUsers.infodecData,
        busyModalTable: state => state.groupsUsers.busyModalTable,
        userInfo: state => state.authorization.userInfo
      }
    )
  },
  methods: {
    openFileLoader: () => {
      document.getElementById('xmlLoader').click()
    },
    modalGroupFCS (data) {
      this.p_gid = data.p_gid
      this.companyDataFromTable = data
      const innKpp = data.inn_kpp.split('/')
      this.companyDataFromTable.inn = innKpp[0].replace(/\s+/g, '')
      if (innKpp[1] === '') {
        this.companyDataFromTable.kpp = 'none'
      } else {
        this.companyDataFromTable.kpp = innKpp[1].replace(/\s+/g, '')
      }
      this.$root.$emit('bv::show::modal', 'ModId3', event)
      this.getGroupFCSData(data).then(
        () => {
          this.loading = true
          this.type = 'group'
        }
      )
    },
    modalSubgroupFCS (data) {
      this.p_gid = data.p_gid
      this.companyDataFromTable = data
      this.$root.$emit('bv::show::modal', 'ModId3', event)
      this.getSubgroupFCSData(data).then(
        () => {
          this.loading = true
          this.type = 'subgroup'
        }
      )
    },
    sendLogic () {
      if (this.type === 'group') {
        this.model.p_default = Number(this.model.p_default)
        this.model.p_emulator = Number(this.model.p_emulator)
        this.model.p_gid = this.p_gid
        this.editFCSData(Object.assign({}, this.model))
      } else if (this.type === 'subgroup') {
        this.model.p_default = Number(this.model.p_default)
        this.model.p_emulator = Number(this.model.p_emulator)
        this.model.p_gid = this.p_gid
        this.editSubgroupFCSData(Object.assign({}, this.model)).then(
          (response) => {
            this.$emit('reloadGroups', response)
          },
          (error) => {
            console.log(error)
          }
        )
      }
    },
    sendModalData (event) {
      event.preventDefault()
      this.onSubmit()
    },
    checkEmulatorField (event) {
      event.preventDefault()
      if (this.model.p_emulator && (this.model.p_username || this.model.p_password || this.model.p_participant_id || this.model.p_sender_info)) {
        this.$bvModal.msgBoxConfirm('Данный профиль подключен к "Эмулятору сообщений", продолжить?', {
          title: '',
          size: 'sm',
          buttonSize: 'sm',
          okTitle: 'Да',
          cancelTitle: 'Нет',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        }).then(value => {
          if (value === true) {
            this.onSubmit()
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.onSubmit()
      }
    },
    clearModal () {
      for (const key in this.model) {
        this.model[key] = null
      }
      this.loading = false
      this.companyDataFromTable = null
    },
    setFCSData (row, index, event) {
      this.model.p_participant_id = row.participant_id
      this.model.p_username = row.login
      this.model.p_password = row.password
      this.model.p_sender_info = row.sender_info
      this.$root.$emit('bv::hide::popover')
    },
    hasDefaultFcsRight () {
      const hasRights = this.userInfo.rights.filter(item => {
        return item === 'default_profile_fcs'
      })
      return (hasRights.length > 0)
    },
    loadXml (event) {
      if (event) {
        const formData = new FormData()
        formData.append('file', event)
        const params = {
          groupType: this.type === 'group' ? 'groups' : 'subgroups',
          groupId: this.companyDataFromTable.p_gid,
          formData
        }
        this.loadDataFromXml(params).then(
          (response) => {
            console.log(response)
            if (this.type === 'group') {
              this.getGroupFCSData(this.companyDataFromTable).then(
                () => {
                  this.loading = true
                  this.type = 'group'
                  this.$emit('reloadGroups', this.modalParamsGroupFCS.method_data)
                  this.xmlFile = null
                }
              )
            } else {
              this.getSubgroupFCSData(this.companyDataFromTable).then(
                () => {
                  this.loading = true
                  this.type = 'subgroup'
                  this.$emit('reloadGroups', this.modalParamsGroupFCS.method_data)
                  this.xmlFile = null
                }
              )
            }
          },
          (error) => {
            this.xmlFile = null
            console.log(error)
          }
        )
      }
    },
    ...mapActions('groupsUsers', [
      'getGroupFCSData',
      'editFCSData',
      'getSubgroupFCSData',
      'editSubgroupFCSData',
      'getDataFromInfodec',
      'loadDataFromXml'
    ])
  }
}
</script>

<style scoped>
  .inline {
    display: inline-flex;
  }

  .infodec-link {
    font-size: 14px;
  }

  .infodec-popover {
    width: 500px;
    max-width: 500px !important;
  }
</style>
